// src/Navbar.js
import Navbar from "../components/Navbar.js";
import "./supplychain.css";
import Footer from "../components/Footer.js";


const SupplyChainPage = () => {

  return (
    <div>
      <Navbar/>
      <div className="spacer"></div>
      {/* Supply Chain Section */}
      <div className="supply-container">
        <div className="supply-header">
          <h1 className="supply-title">Let Your Supply Chain <br />Think Ahead </h1>
          <p className="supply-description">
            Your supply chain shouldn't feel like a guessing game. With
            Argus,you get real time visibility,early warnings , and smart
            automation that keeps things moving without the chaos. We help you
            spot the hiccups before they become headaches, so your team can stop
            firefighting and start fine-tuning. Less stress, more control.
          </p>
        </div>
      </div>

      <div className="containerSupply">
        <div className="image-sectionSupply">
          <img src="supply1.png" alt="Product Line" />
        </div>
        <div className="contentSupply">
          <h1>ENHANCED DELIVERY EFFICIENCY</h1>
          <hr style={{ maxWidth: "100%" }}></hr>
          <h4 style={{ fontWeight: "300" }}>
            Streamline logistics to ensure faster fulfilment and higher customer
            satisfaction
          </h4>
          <ul className="featuresSupply">
            <li>Reduce Lead Time</li>
            <li>Lower Operational Costs</li>
          </ul>
        </div>
      </div>

      <div className="container">
        <div className="content">
          <h1>GREATER TRANSPARENCY AND TRUST</h1>
          <hr style={{ maxWidth: "100%" }}></hr>
          <h4 style={{ fontWeight: "300" }}>
            Increase Customer Confidence through Traceability and Product Origin
            Tracking
          </h4>
          <ul className="features">
            <li>Product Journey Tracking</li>
            <li>Reducing Material wastage and Improving Efficiency</li>
          </ul>
        </div>
        <div className="image-section">
          <img src="supply_!.png" alt="Product Line" />
        </div>
      </div>

      <div className="containerSupply">
        <div className="image-sectionSupply">
          <img src="supply_3.png" alt="Product Line" />
        </div>
        <div className="contentSupply">
          <h1>IMPROVED INVENTORY MANAGEMENT</h1>
          <hr style={{ maxWidth: "100%" }}></hr>
          <h4 style={{ fontWeight: "300" }}>
            Optimise Stock levels for better Product Availability and Customer
            Satisfaction
          </h4>
          <ul className="featuresSupply">
            <li>Minimize Overproduction and stockout effectively.</li>
            <li>Reducing Material wastage </li>
          </ul>
        </div>

      </div>
<div>

</div>
      <Footer />
    </div>
  );
};

export default SupplyChainPage;
